/** Interval (ms) for polling async AI job status (note reformat / extract). */
export const AI_JOB_POLL_INTERVAL_MS = 2000
